
export const BREAKPOINTS = {
    tabletPortrait: 600,
    tabletLandscape: 900,
    desktop: 1200,
    desktopBig: 1800,
    lowHeight: 600
}